import React from "react";
import {Card, f7} from "framework7-react";

import "./EarnMoney.css";
import {useTranslation} from "react-i18next";

export const EarnMoney = () => {
    const { t } = useTranslation();
    return (
        <>
            <Card className="earnmoney-action">
                <div className='earnmoney-action-btn' onClick={() => f7.views.main.router.navigate('/tickets/')}>
                    <p className="earnmoney-title">{t("dashboard.earnMoney")}</p>
                    <p className="earnmoney-subtitle">{t("dashboard.tapToEarnMoney")}</p>
                </div>
            </Card>
        </>
    );
};
